import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import api from '@/api';
import util from '@/libs/util.js';
export default {
  name: 'Setting',
  data: function data() {
    return {
      isSelect: this.checkauthority(''),
      isCreate: this.checkauthority(''),
      isUpdate: this.checkauthority('setting_update'),
      isDelete: this.checkauthority(''),
      activeName: 'second',
      uploadUrl: process.env.VUE_APP_API,
      uploadHeaders: {
        Authorization: util.cookies.get('token')
      },
      form: {
        name: '',
        logo: '',
        isFull: '',
        isLange: '',
        isSubject: '',
        isSearch: '',
        isLog: '',
        isFont: '',
        isColor: '',
        WxMinilogoImg: '',
        wxMiniImage: '',
        logoImg: '',
        ossType: null,
        localFile: null,
        localDns: null,
        aliBucketName: null,
        aliEndpoint: null,
        aliAccessKeyId: null,
        aliAccessKeySecret: null,
        aliOssDns: null,
        txBucketName: null,
        txEndpoint: null,
        txAccessKeyId: null,
        txAccessKeySecret: null,
        txOssDns: null
      },
      rules: {
        name: [{
          required: true,
          message: '请输入后台名称',
          trigger: 'blur'
        }],
        logo: [{
          required: true,
          message: '请输入后台图标',
          trigger: 'blur'
        }],
        isFull: [{
          required: true,
          message: '请输入开启全屏',
          trigger: 'blur'
        }],
        isLange: [{
          required: true,
          message: '请输入开启多语言',
          trigger: 'blur'
        }],
        isSubject: [{
          required: true,
          message: '请输入开启切换主体',
          trigger: 'blur'
        }],
        isSearch: [{
          required: true,
          message: '请输入开启搜索',
          trigger: 'blur'
        }],
        isLog: [{
          required: true,
          message: '请输入开启日志',
          trigger: 'blur'
        }],
        isFont: [{
          required: true,
          message: '请输入开启字体设置',
          trigger: 'blur'
        }],
        isColor: [{
          required: true,
          message: '请输入开启主体颜色',
          trigger: 'blur'
        }],
        wxMiniAppid: [{
          required: true,
          message: '小程序Appid不能为空',
          trigger: 'blur'
        }],
        wxMiniSecret: [{
          required: true,
          message: '小程序Secret不能为空',
          trigger: 'blur'
        }],
        wxMiniName: [{
          required: true,
          message: '小程序名称不能为空',
          trigger: 'blur'
        }],
        wxMiniImage: [{
          required: true,
          message: '小程序图标不能为空',
          trigger: 'blur'
        }],
        wxMiniAgreement: [{
          required: true,
          message: '服务协议不能为空',
          trigger: 'blur'
        }],
        wxMiniPrivacy: [{
          required: true,
          message: '隐私政策不能为空',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    wximageHandleAvatarSuccess: function wximageHandleAvatarSuccess(res, file) {
      if (res.code === 200) {
        this.$message.success('上传成功');
      }
      this.form.wxMiniImage = res.body.url;
      this.form.WxMinilogoImg = res.body.dnsUrl + '/' + res.body.url;
      this.activeName = 'first';
      this.activeName = 'second';
    },
    wximageBeforeAvatarUpload: function wximageBeforeAvatarUpload(file) {
      var type = file.type;
      var isJPG = false;
      if (type === 'image/jpeg') {
        isJPG = true;
      } else if (type === 'image/png') {
        isJPG = true;
      } else {
        isJPG = false;
      }
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG,PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      if (res.code === 200) {
        this.$message.success('上传成功');
      }
      this.form.logo = res.body.url;
      this.form.logoImg = res.body.dnsUrl + '/' + res.body.url;
      this.activeName = 'first';
      this.activeName = 'second';
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var type = file.type;
      var isJPG = false;
      if (type === 'image/jpeg') {
        isJPG = true;
      } else if (type === 'image/png') {
        isJPG = true;
      } else {
        isJPG = false;
      }
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG,PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },
    handleClick: function handleClick(tab, event) {
      console.log(tab, event);
    },
    update: function update() {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this.form.settingId != null) {
            _this.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this.updateApi();
            }).catch(function () {
              _this.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this.updateApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    updateApi: function updateApi() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.UPDATE_SETTING(_this2.form);
            case 1:
              _this2.$message.success('操作成功');
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    initDataApi: function initDataApi() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par, result;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                settingId: 1
              };
              _context2.n = 1;
              return api.GET_SETTING_INFO(par);
            case 1:
              result = _context2.v;
              _this3.form = result.body;
              _this3.form.logoImg = process.env.VUE_APP_DOWNLOAD_URL + '/' + result.body.logo;
              _this3.form.WxMinilogoImg = process.env.VUE_APP_DOWNLOAD_URL + '/' + result.body.wxMiniImage;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    }
  },
  created: function created() {
    this.initDataApi();
  }
};